/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { getTimestampAsDate } from '../../common/UtilityFunctions';
import Styles from '../../css/ServicerEscrowAnalysis.module.css';

const EscrowMonthsTable = (trialBalances: Array<any>) => {
  return (
    <div className={Styles.bigtable}>
      <Table className={Styles.taxTable}>
        <TableHead>
          <TableRow>
            <TableCell align='right'>Type</TableCell>
            <TableCell align='right'>Payment Date</TableCell>
            <TableCell align='right'>Deposits</TableCell>
            <TableCell align='right'>Disbursements</TableCell>
            <TableCell align='right'>Estimated Balance</TableCell>
            <TableCell align='right'>Projected Balance</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.values(trialBalances).map((row) => (
            <TableRow key={row.$index}>
              <TableCell align='left'>{row.remitType}</TableCell>
              <TableCell align='right'>{getTimestampAsDate(row.paymentDate)}</TableCell>
              <TableCell align='right'>{parseFloat(row.impoundReceived).toFixed(2)}</TableCell>
              <TableCell align='right'>{parseFloat(row.amountRemitted).toFixed(2)}</TableCell>
              {/* trialBalances.projectedBalance maps to estimated balance on the display 
              since trialBalances.projectedBalance is the balance of the month based on the current escrow balances */}
              <TableCell align='right'>{parseFloat(row.projectedBalance).toFixed(2)}</TableCell>
              {/* trialBalances.trialBalance maps to the projected balance on the display 
              since trialBalances.trialBalance is the required balance for the month based on the shortage / surplus of the aea period 
              given the current escrow balance*/}
              <TableCell align='right'>{parseFloat(row.trialBalance).toFixed(2)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default EscrowMonthsTable;
